import React from "react";
import "@/app/pages/companyProfile/financial/CompanyNewFinancialsStyles.scss";
import { formatData } from "@/shared/FunctionCore";

const Stakeholder = ({ props }) => {
  return (
    <>
      <table>
        <thead>
          <th className="statement_name th" scope="col">
            Stakeholder's Equity (MIL)
          </th>
          {props.stakeholderDetails.stakeholderYear.map((stakeholderYear) => (
            <>
              <th className="statement_year th" scope="col">
                {stakeholderYear}
              </th>
            </>
          ))}
        </thead>
        <tbody>
          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Equity
            </th>
            {props.stakeholderDetails.commonStock.map((netOperatingCash) => (
              <>
                <td className="statement_year th" scope="col"></td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Common Stock
            </th>
            {props.stakeholderDetails.commonStock.map((commonStock) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(commonStock)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Retained Earnings
            </th>
            {props.stakeholderDetails.retainedEarnings.map(
              (retainedEarnings) => (
                <>
                  <td className="statement_year th" scope="col">
                    {formatData(retainedEarnings)}
                  </td>
                </>
              )
            )}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Equity Summary
            </th>
            {props.stakeholderDetails.commonStock.map((commonStock) => (
              <>
                <td className="statement_year th" scope="col"></td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Total Equity
            </th>
            {props.stakeholderDetails.totalEquity.map((totalEquity) => (
              <>
                <td className="statement_year th" scope="col">
                  {formatData(totalEquity)}
                </td>
              </>
            ))}
          </tr>

          <tr className="data_point">
            <th className="data_point_name" scope="row">
              Shares Outstanding
            </th>
            {props.stakeholderDetails.sharesOutstanding.map(
              (sharesOutstanding) => (
                <>
                  <td className="statement_year th" scope="col">
                    {formatData(sharesOutstanding)}
                  </td>
                </>
              )
            )}
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default Stakeholder;
